import React from 'react';
import { Button, Icon } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { HiOutlinePlus } from 'react-icons/hi';
import { Link } from 'react-router-dom';
import { PATH_QUESTIONNAIRE_TEMPLATE_CREATE } from '../../../../../routes/constants';

export const CreateTemplateButton = () => {
  const { t } = useTranslation();

  return (
    <Link to={PATH_QUESTIONNAIRE_TEMPLATE_CREATE}>
      <Button px={4} py={2} borderRadius="xl" colorScheme="blue" leftIcon={<Icon as={HiOutlinePlus} w={5} h={5} color="white" />}>
        {t('administration:questionnaireTemplate.buttonTitle')}
      </Button>
    </Link>
  );
};
